import { Link } from 'react-router-dom';
import './home.css';
import { useContext } from 'react';
import { DisplayContext } from '../../context/display.context'

export default function Home() {

    const deviceWidth = useContext(DisplayContext);

    return (
        <>
            <section className="wrapper home-hiro">
                <div>
                    <div>
                        <hgroup>
                            <h2 className="text-nowrap">Let the Game Begin!</h2>
                            <h3 className="text-nowrap">Thousands of dollars to be won!</h3>
                            <h3 className="text-nowrap">Play &bull; Win &bull; Get Paid</h3>
                        </hgroup>
                        <Link to='/games' className="btn btn-lg  play-btn">Play Now</Link>
                        &nbsp;&nbsp;
                        <Link to='/explore' className="btn btn-lg btn-outline-light">Explore</Link>
                        
                    </div>
                </div>
                <div>
                    <img alt="" src="/images/m.png" />
                </div>
            </section>

            <section className={`wrapper instruction d-md-flex align-item-strech justify-content-between`}>
                <div className={`flex-fill d-flex flex-column align-items-center justify-content-center ${deviceWidth > 768 ? 'p-5 w-50' : ''}`}>
                    <div className="h-100 p-3 d-flex flex-column align-items-center justify-content-center">
                        <img alt="" className="play" src="images/play.png" />
                    </div>
                </div>
                <div className={`flex-fill d-flex flex-column align-items-center justify-content-center ${deviceWidth > 768 ? 'p-5 w-50' : 'p-4'}`}>
                    <div className={`text-white `}>
                        <h2 className='d-flex align-items-center'>
                            <span className="rounded-circle bg-warning text-black me-3 d-flex align-items-center justify-content-center" style={{width:'50px', height:'50px'}}>1</span>
                            <span>Play</span>
                        </h2>
                        <p className='text-justify'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                            Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                            when an unknown printer took a galley of type and scrambled it to make a
                        </p>
                    </div>
                    <div className="text-white">
                        <h2 className='d-flex align-items-center'>
                            <span className="rounded-circle bg-warning text-black me-3 d-flex align-items-center justify-content-center" style={{width:'50px', height:'50px'}}>2</span>
                            <span>Win</span>
                        </h2>
                        <p className='text-justify'>
                            type specimen book. It has survived not only five centuries, but also the
                            leap into electronic typesetting, remaining essentially unchanged. It was
                            popularised in the 1960s with the release of Letraset sheets.
                        </p>
                    </div>
                    <div className="text-white">
                        <h2 className='d-flex align-items-center'>
                            <span className="rounded-circle bg-warning text-black me-3 d-flex align-items-center justify-content-center" style={{width:'50px', height:'50px'}}>3</span>
                            <span>Claim</span>
                        </h2>
                        <p className='text-justify'>Containing Lorem
                            Ipsum passages, and more recently with desktop publishing software like Aldus
                            PageMaker including versions of Lorem Ipsum.</p>
                    </div>
                </div>
            </section>
        </>
    )
}